const IsProduction = () => {
  return process.env.NODE_ENV === 'production';
}

export default IsProduction;
